<template>
  <button-base medium="web-share-api" :label="label" :title="label" :aria-label="label" class="web-share-api"
               @click="launchShare" />
</template>

<script>
import ButtonBase from './button-base'
import { inject } from 'vue'
import WebShareApiMixin from '@/share/campaign/web-share-api-mixin'

export default {
  components: { ButtonBase },

  mixins: [WebShareApiMixin],

  props: {
    label: {
      type: String,
      required: false,
      default() { return inject('i18n').t('social.share_anywhere') }
    }
  }
}
</script>
